import * as stylex from "@stylexjs/stylex";
import { recipes } from "@/design/recipes";
import "@/design/tokens.stylex";
import { colors, radii, space, text } from "@/design/tokens.stylex";

// The branded line an exported PNG or CSV opens with. Hidden on screen (the
// page header and chip row already say all of it); the exporter shows it for
// the capture with an inline `display: flex`.
const styles = {
  header: {
    k1xSpc: "x1s85apg",
    kGNEyG: "x1cy8zhl",
    kwnvtZ: "x1a02dak",
    kOIVth: "x1l51sop",
    kGO01o: "xoq5v3y",
    $$css: true
  }
};
export interface AnalyticsExportHeaderProps {
  organizationName: string;
  logoUrl: string | null | undefined;
  dateRange: {
    start: string;
    end: string;
  };
  segmentName?: string | null;
  breakdownNames?: string[];
  sectionName?: string;
  reportContext?: string;
}
export default function AnalyticsExportHeader({
  organizationName,
  logoUrl,
  dateRange,
  segmentName,
  breakdownNames = [],
  sectionName,
  reportContext
}: AnalyticsExportHeaderProps) {
  const period = `${dateRange.start} – ${dateRange.end}`;
  const context = [period, sectionName, segmentName && `Filter: ${segmentName}`, breakdownNames.length > 0 && `Breakdowns: ${breakdownNames.join(", ")}`, reportContext].filter(Boolean).join(" · ");
  return <div data-export-header {...stylex.props(styles.header, recipes.hairlineBottomSoft)} aria-hidden="true">
      <div className="x78zum5 x6s0dn4 x166cprz xgwkh9f xdj3nnt xk50ysn">
        {logoUrl ? <img src={logoUrl} alt="" className="xgd8bvy x1fgtraw x2lah0s x1wpy2cq x19kjcj4" /> : null}
        <span>{organizationName}</span>
      </div>
      <span className="x1iyjqo2 xs83m0k xchdapg x1e3avs9 x1hr2gdg x7x6yu3 x1evy7pa xj0a0fe">{context}</span>
    </div>;
}